<template>
  <div class="award-bg">
    <div v-html="award"></div>
  </div>
</template>

<script>
import { Button } from "vant";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import "@/plugins/bridge.js";

export default {
  name: "awardPage",
  components: {
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();

    const showBtn = ref(false);

    const userAgentString = navigator.userAgent.toLowerCase();
    if (userAgentString.indexOf("zsrbapp") < 0) {
      showBtn.value = true;
    }

    return {
      showBtn,
      award: computed(() => store.state.award),
    };
  },
};
</script>

<style lang="scss" scoped>
.award-bg {
  width: 85%;
  // min-height: 200px;
  text-align: left;
  margin: 30px;
}
.button {
  margin-bottom: 50px;
}
</style>
